export const getInstructionWithoutHiddenPartWithTrim = (
  instruction: string,
): string => {
  if (!instruction) return "";

  let result = instruction.replace(/<security>[\s\S]*?<\/security>/g, "");

  result = result.replace(/\n{3,}/g, "\n\n");

  return result.replace(/^\s+|\s+$/g, "");
};

export const removeSecurityTags = (input: string): string => {
  return input.replace(/<security\b[^>]*>[\s\S]*?<\/security>/gi, "");
};

export const getInstructionWithoutHiddenPart = (instruction: string) =>
  instruction.replace(/<security>[\s\S]*?<\/security>/g, "");
